export const GET_ROBOT_DATA = 'GET_ROBOT_DATA';
export const GET_PROVINCES = 'GET_PROVINCES';
export const GET_CITIES = 'GET_CITIES';
export const GET_BRAND = 'GET_BRAND';
export const GET_MODEL = 'GET_MODEL';
export const GET_YEARS_OF_MODEL = 'GET_YEARS_OF_MODEL';
export const UPDATE_MODAL = 'UPDATE_MODAL';
